/* eslint-disable no-use-before-define */
import React from 'react';
import TextField from '@material-ui/core/TextField';
import { makeStyles } from '@material-ui/core/styles';
import Autocomplete from '@material-ui/lab/Autocomplete';

const useLabelStyles = makeStyles({
  textFieldRoot: {
    '& .MuiOutlinedInput-root': {
      height: 'clamp(28px, calc(9px + 1.47vw), 38px)',
      boxSizing: 'border-box',
      display: 'flex',
      alignItems: 'center',
    },
    '& .MuiOutlinedInput-input': {
      paddingTop: '0 !important',
      paddingBottom: '0 !important',
    },
  },
  shrink: {
    // compensate for scale(0.85) wrapper in PatientTable header
    fontSize: 'clamp(0.776rem, calc(0.342rem + 0.646vw), 1.118rem)',
    fontWeight: 'normal',
    letterSpacing: '0.6px',
  },
  input: {
    '&::placeholder': {
      color: '#002D55',
      fontWeight: 'bold',
      fontSize: 'clamp(0.775rem, calc(0.342rem + 0.646vw), 1.118rem)',
      letterSpacing: '0.6px',
      opacity: 1,
      transition: 'opacity 0.2s',
    },
    '&:focus::placeholder': {
      opacity: 0.3,
    },
    fontSize: 'clamp(0.775rem, calc(0.342rem + 0.646vw), 1.118rem) !important',
    padding: '0 0 0 4px !important',
  },
  // Override Autocomplete root wrapper padding (MuiAutocomplete-inputRoot sets padding:9px)
  // Values compensated ÷0.85 for scale(0.85) wrapper so visual spacing matches DiagnosisCell
  root: {
    height: 'clamp(28px, calc(9px + 1.47vw), 38px) !important',
    paddingTop: '0 !important',
    paddingBottom: '0 !important',
    paddingLeft: 'clamp(7.06px, calc(0px + 0.49vw), 9.41px) !important',
    boxSizing: 'border-box',
  },
  autoInputRoot: {
    // Keep enough room for clear + popup icons while reducing excess right-side whitespace.
    paddingRight: 'clamp(36px, calc(26px + 1.4vw), 46px) !important',
  },
  endAdornment: {
    right: 'clamp(2px, calc(-1px + 0.5vw), 6px)',
  },
  option: {
    // Compensate for the scale(0.85) wrapper in PatientTable header.
    fontSize: 'clamp(0.66rem, calc(0.291rem + 0.549vw), 0.95rem) !important',
    letterSpacing: '0.6px',
    lineHeight: 1.2,
  },
  responsiveOption: {
    fontSize: 'inherit',
    letterSpacing: 'inherit',
  },
  paper: {
    borderRadius: 14,
  },
  notchedOutline: {
    borderRadius: 18,
  },
});



const Searchbar = ({profiles, searchInput, setSearchInput, className, disabled, displayValue, selectedPatient, setSelectedPatient, onChange}) => {
  const labelClasses = useLabelStyles();

  return (
    // allow the searchbar container to shrink on small screens using CSS clamp()
    <div style={{ minWidth: 'clamp(60px, 28.2vw, 250px)', backgroundColor: "transparent" }}>
      <Autocomplete
        classes={{ paper: labelClasses.paper, inputRoot: labelClasses.autoInputRoot, endAdornment: labelClasses.endAdornment, option: labelClasses.option }}
        renderOption={(option) => (
          <div className={labelClasses.responsiveOption}>{`${option.first_name} ${option.last_name}`}</div>
        )}
        options={profiles}
        disableClearable={false}
        getOptionLabel={(option) => `${option.first_name} ${option.last_name}`}
        getOptionSelected={(option, value) => {
          // Match by user_id to avoid reference equality issues
          const optionId = option?.user_id || option?.id;
          const valueId = value?.user_id || value?.id;
          return optionId === valueId;
        }}
        value={selectedPatient}
        inputValue={searchInput}
        onInputChange={(event, newInputValue, reason) => {
          if (disabled) return;
          if (reason === 'input' || reason === 'clear') {
            setSearchInput(newInputValue);
          }
        }}
        onChange={(event, newValue) => {
          if (!disabled) setSearchInput('');
          // Call setSelectedPatient with the profile - it may be handleSelectProfile which needs the full profile
          if (newValue) {
            setSelectedPatient(newValue);
          } else {
            // When clearing (X button), pass null to clear selection
            setSelectedPatient(null);
          }
        }}
        renderInput={(params) => (
      <TextField
        {...params}
        className={[className, labelClasses.textFieldRoot].filter(Boolean).join(' ')}
        placeholder='Patient'
        variant="outlined"
        InputProps={{
          ...params.InputProps,
          type: 'text',
          disabled,
          classes: { input: labelClasses.input, root: labelClasses.root, notchedOutline: labelClasses.notchedOutline },
          style: { backgroundColor: '#FFF', borderRadius: 18, overflow: 'hidden' },
        }}
        InputLabelProps={{
          shrink: false,
          style: {
            fontWeight: 'bold',
            letterSpacing: '0.6px',
          },
          classes: { shrink: labelClasses.shrink }
        }}
      />
  )}
/>
    </div>
  );
}

export default Searchbar


